import { useState, useEffect, useContext } from 'react';
import { GridColDef, GridRenderCellParams, GridRowParams, GridRowSelectionModel } from '@mui/x-data-grid';
import Table from '../custom/Table';
import Title from '../custom/Title';
import { Button, IconButton, Stack, TextField, Tooltip } from "@mui/material";
import Modal from '../Modals';
import VisibilityIcon from '@mui/icons-material/Visibility';
import useService from '../../hooks/useService';
import { createOrUpdateStockRequest, fetchBusinessUnits, getAllProduct, getStockRequest } from '../../services/Inventory'
import { InventoryContext } from '../../contexts/InventoryContext';
import { AuthContext } from '../../contexts/AuthContext';
import moment from 'moment';
import CreateNewRequest from './CreateNewRequest';
import { CreateRequestData, TCreateStockReqParams, TStockReqDetail } from '../../Models/Inventory';
import DeleteIcon from '@mui/icons-material/Delete';
import { NotificationContext } from '../../contexts/NotificationContext';
import { REQUEST_STATUS } from '../../utils/constant';

const OUTGOING_REQUEST_TABLE = [
    {
        id: 'action',
        label: 'Action',
    },
    {
        id: 'requestorCenter',
        label: 'Requestor Center',
    },
    {
        id: 'requestedCenter',
        label: 'Requested Center',
    },
    {
        id: 'status',
        label: 'Status',
    },
    {
        id: 'createdAt',
        label: 'Created At',
    },
    {
        id: 'updatedAt',
        label: 'Updated At',
    },
]

export const SHOW_OUT_REQUEST_TABLE = [
    {
        id: 'productName',
        label: 'Product Name',
    },
    {
        id: 'metalType',
        label: 'Metal Type',
    },
    {
        id: 'quantity',
        label: 'Quantity',
    },
    {
        id: 'createdAt',
        label: 'Created At',
    },
    {
        id: 'updatedAt',
        label: 'Updated At',
    },
    {
        id: 'action',
        label: 'Delete',
    },

]

export const OutgoingRequest = () => {

    const { user } = useContext(AuthContext)
    const { execute } = useService()
    const { stockRequest } = useContext(InventoryContext)
    const [showStockRequestDetail, setShowStockRequestDetail] = useState<boolean | TStockReqDetail>(false)
    const [newRequest, setNewRequest] = useState<boolean | string>(false)
    const [currentReq, setCurrentReq] = useState("")
    // eslint-disable-next-line array-callback-return
    // const showRequest = stockRequest.filter((stock) => {
    //     if (stock.requestorCenter === user.centerId) return stock
    // })
    // const updated_at = inventories?.data && inventories.data[0]?.updatedAt
    // const lastUpdatedAt = inventories?.data ? moment(updated_at).clone().utcOffset('+05:30').format('h:mm a, Do MMM') : ''

    useEffect(() => {
        execute(() => fetchBusinessUnits({ channelId: user.centerId! }))
        execute(() => getAllProduct({}))
        execute(() => getStockRequest({}))
    }, [])

    const closeReqModal = () => {
        setNewRequest(false)
    }
    const closeStockDetails = () => {
        setShowStockRequestDetail(false)
    }
    const getStockRequestsCoumns = () => {

        return OUTGOING_REQUEST_TABLE.map(field => {

            const row: GridColDef = {
                field: field.id,
                headerName: field.label,
                minWidth: 200,
                align: 'left'
            }

            switch (field.id) {
                case "action":
                    row.minWidth = 150;
                    row.renderCell = params => {
                        return <>{params.row.id ?
                            <Tooltip title='View details'>
                                <IconButton style={{ marginLeft: '-10px' }} onClick={() => {
                                    setCurrentReq(params.row)
                                    setShowStockRequestDetail(params.row.lineItem)
                                }
                                }><VisibilityIcon /></IconButton>
                            </Tooltip> : "NA"
                        }</>
                    }
                    break;
                case "requestorCenter":
                    row.minWidth = 190;
                    break;
                case "requestedCenter":
                    row.minWidth = 190;
                    break;
                case "status":
                    row.minWidth = 170;
                    break;
                case "createdAt":
                    row.minWidth = 200;
                    row.renderCell = params => {
                        return params.row.updatedAt ? moment(params.row.createdAt).clone().utcOffset('+05:30').format('hh:mm a, Do MMM, YYYY') : "NA"
                    }
                    break;
                case "updatedAt":
                    row.minWidth = 200;
                    row.renderCell = params => {
                        return params.row.updatedAt ? moment(params.row.updatedAt).clone().utcOffset('+05:30').format('hh:mm a, Do MMM, YYYY') : "NA"
                    }
                    break;
            }

            return row;
        })
    }

    return (
        <div style={{ padding: '0 10px' }}>
            <div style={{ borderBottom: '1px solid #d8d8d8', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Title style={{ textAlign: 'left', margin: '20px 10px 10px 10px', color: '#7f7d76' }}>Outgoing Request</Title>
                <Button color="primary" variant='contained' onClick={() => setNewRequest('true')}>{'Create new request'}</Button>
            </div>
            <Table columns={getStockRequestsCoumns()} rows={stockRequest ?? []} />
            <Modal open={typeof newRequest != 'boolean'} title={'Create New Request'} onClose={closeReqModal} maxWidth={'xl'}>
                <CreateNewRequest onClose={closeReqModal} />
            </Modal>
            <Modal open={typeof showStockRequestDetail != 'boolean'} title={'View Details'} onClose={closeStockDetails} maxWidth={'xl'}>
                <ShowOutgoingStockDetails currentReq={currentReq} data={showStockRequestDetail} onClose={closeStockDetails} />
            </Modal>
        </div>
    )
}

export function ShowOutgoingStockDetails({ currentReq, data, onClose }: { currentReq: any, data: any, onClose: any }) {
    const [rows, setRows] = useState<CreateRequestData[]>(data as CreateRequestData[])
    const [rowSelectionModel, setRowSelectionModel] = useState<GridRowSelectionModel>([]);
    const { execute } = useService()
    const [isDisabled, setIsDisabled] = useState(false)
    const { notify } = useContext(NotificationContext);

    useEffect(() => {
        handleSelection()
        if (currentReq.status !== REQUEST_STATUS.PENDING )
            setIsDisabled(true)
    }, [])

    const handleSelection = () => {
        let updatedRow: CreateRequestData[] = []

        rows?.forEach((row: CreateRequestData) => {
            console.log("row areee", row)
            if (currentReq.status === "pending") {
                row['isEditable'] = true
            } else {
                row['isEditable'] = false
            }
            updatedRow.push(row as CreateRequestData)
        })
        setRows(updatedRow)
    };

    const handleChange = (e: any, params: GridRenderCellParams) => {
        console.log("params are--", params)
        let value = e.target.value
        if (Number(value) < 0) value = 0

        let updatedRows: CreateRequestData[] = []

        rows.forEach((row: CreateRequestData) => {
            if (params.row.id === row.id) {
                if (currentReq.status === REQUEST_STATUS.PENDING)
                    row['reqQuantity'] = Number(value)
                updatedRows.push(row)
            }
            else {
                updatedRows.push(row)
            }
        })
        console.log("updated rows==", updatedRows)
        setRows(updatedRows as CreateRequestData[])
    }

    const handleDeleteReq = (id: any) => {

        if (currentReq.status === REQUEST_STATUS.PENDING) {
            let rowsAfterDel = rows.filter((row) => {
                if (row.id !== id) return row
            })
            setRows(rowsAfterDel)
        }
    }

    const getStockColumn = () => {
        return SHOW_OUT_REQUEST_TABLE.map(field => {

            const row: GridColDef = {
                field: field.id,
                headerName: field.label,
                minWidth: 100,
                align: 'left'
            }

            switch (field.id) {
                case "action":
                    row.minWidth = 60;
                    row.renderCell = params => {
                        return <>{params.row.id ?
                            <Tooltip title='Delete Request'>
                                <IconButton style={{ marginLeft: '-10px' }} onClick={() => handleDeleteReq(params.row.id)}><DeleteIcon /></IconButton>
                            </Tooltip> : "NA"
                        }</>
                    }
                    break;
                case "quantity":
                    row.minWidth = 150;
                    row.type = 'number';
                    row.headerAlign = 'left';
                    row.renderCell = params => {
                        return <TextField
                            fullWidth
                            size="small"
                            variant="outlined"
                            value={params.row.reqQuantity}
                            onChange={(e) => handleChange(e, params)}
                            type={'number'}
                        // disabled={!rowSelectionModel.includes(params.row.id)}
                        />
                    }
                    break;
                case "productName":
                    row.minWidth = 550;
                    break;
                case "createdAt":
                    row.minWidth = 150;
                    break;
                case "updatedAt":
                    row.minWidth = 150;
                    break;
            }

            return row;
        })
    }

    const handleRowSelectionModel = (newRowSelectionModel: GridRowSelectionModel) => {
        setRowSelectionModel(newRowSelectionModel);

    }

    const handleSubmit = async () => {
        let payload: TCreateStockReqParams = {}
        const Ids: any = []
        rows?.forEach((el) => {
            Ids.push({ id: el.id, skuId: el.skuId, quantity: el.reqQuantity })
        })
        payload.id = currentReq.id
        payload.lineItems = Ids

        const { error } = await execute(() => createOrUpdateStockRequest(payload))
        if (!error) {
            notify('Stock Request Updated Successfully!');
            execute(() => getStockRequest({}))
            onClose()
        } else {
            notify(error.reason, 'error');
        }
    }
    return (
        <div style={{ padding: '0 10px', width: '760px' }}>
            <Table
                columns={getStockColumn()}
                rows={rows ?? []}
                editMode="row"
                getRowId={(row) => row.id}
                checkboxSelection
                disableRowSelectionOnClick
                isRowSelectable={(params: GridRowParams) => params.row.isEditable}
                onRowSelectionModelChange={handleRowSelectionModel}
                rowSelectionModel={rowSelectionModel}
                processRowUpdate={(newRow) => {
                    const updatedRow = { ...newRow }
                    let updatedRows = rows.map((row: CreateRequestData) => (row.id === newRow.id ? updatedRow : row))
                    setRows(updatedRows as CreateRequestData[])
                    return updatedRow
                }}
            />
            <Stack width="100%" marginTop="25px" direction="row" justifyContent="flex-end" gap="10px" align-items="center">
                <Button onClick={onClose}>Close</Button>
                <Button color="primary" variant="contained" disabled={isDisabled} onClick={handleSubmit} >{ currentReq.status===REQUEST_STATUS.PENDING ? 'Update' : `Already ${currentReq.status}`}
                </Button>
            </Stack>
        </div>
    )
}